import * as base64js from 'base64-js';

export const getAuthHeader = (userAddress, signedTimestamp, signedData) => {
    let authHeaderData = `${userAddress}:${signedTimestamp}:${signedData}`
    const bytes = new TextEncoder().encode(authHeaderData);
    return base64js.fromByteArray(bytes);
}